module.exports = __webpack_public_path__ + "media/images/icons/twotone/shop-5e4b69178c9295249e593b9ca1f44787.svg";